import React from 'react';
import EnumInput from '../../../../misc/EnumInput';
import { CoreTeamsFixStandardSettings, GroupSettings, MemberSettings, MessagingSettings, SharePointSiteSettings, StandardSettingBehaviour } from '../../../../../models/TeamsFixTypes';
import { useTranslation } from 'react-i18next';

interface TeamsFixStandardSettingsProps {
    teamsFixSettings: CoreTeamsFixStandardSettings
    disabled: boolean
    onChange: (x: CoreTeamsFixStandardSettings) => void
    name: string
}

const TeamsFixStandardSettingsComponent: React.FC<TeamsFixStandardSettingsProps> = (props) => {
    const { t } = useTranslation(['configuration']);

    const settings = props.teamsFixSettings;

    const notifyChange = (change: Partial<CoreTeamsFixStandardSettings>) => {
        props.onChange({
            ...settings,
            ...change
        });
    }

    return (<>
        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.standardSettingsBehavior.title', { ns: 'configuration' })}
            name={props.name + ".settingsBehaviour"}
            value={settings.settingBehaviour}
            options={StandardSettingBehaviour.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.standardSettingsBehavior.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ settingBehaviour: v })}
            disabled={props.disabled}
            multi={false}
        />

        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.messagingSettings.title', { ns: 'configuration' })}
            name={props.name + ".messagingSettings"}
            value={settings.messagingSettings}
            options={MessagingSettings.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.messagingSettings.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ messagingSettings: v })}
            disabled={props.disabled}
            multi={true}
        />

        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.memberSettings.title', { ns: 'configuration' })}
            name={props.name + ".memberSettings"}
            value={settings.memberSettings}
            options={MemberSettings.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.memberSettings.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ memberSettings: v })}
            disabled={props.disabled}
            multi={true}
        />

        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.sharePointSiteSettings.title', { ns: 'configuration' })}
            name={props.name + ".sharePointSiteSettings"}
            value={settings.sharePointSiteSettings}
            options={SharePointSiteSettings.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.sharePointSiteSettings.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ sharePointSiteSettings: v })}
            disabled={props.disabled}
            multi={true}
        />

        <EnumInput
            title={t('oneRosterConfiguration.teamsFix.settings.groupSettings.title', { ns: 'configuration' })}
            name={props.name + ".groupSettings"}
            value={settings.groupSettings}
            options={GroupSettings.map(x => ({ value: x, text: t(`oneRosterConfiguration.teamsFix.settings.groupSettings.options.${x}`, { ns: 'configuration' }) }))}
            onChange={(n, v) => notifyChange({ groupSettings: v })}
            disabled={props.disabled}
            multi={true}
        />
    </>);
}

export default TeamsFixStandardSettingsComponent;
